import * as T from './loyaltyNotificationsTypes';
import type { LoyaltyNotificationsAction } from './loyaltyNotificationsActions';

export interface LoyaltyNotificationsState {
  configs: any[];
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: LoyaltyNotificationsState = {
  configs: [],
  loading: false,
  saving: false,
  error: null,
};

export default function loyaltyNotificationsReducer(
  state = initialState,
  action: LoyaltyNotificationsAction
): LoyaltyNotificationsState {
  switch (action.type) {
    case T.FETCH_NOTIFICATION_CONFIGS_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_NOTIFICATION_CONFIGS_SUCCESS:
      return { ...state, loading: false, configs: action.payload };
    case T.FETCH_NOTIFICATION_CONFIGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case T.UPDATE_NOTIFICATION_CONFIG_REQUEST:
      return { ...state, saving: true, error: null };
    case T.UPDATE_NOTIFICATION_CONFIG_SUCCESS:
      return {
        ...state,
        saving: false,
        configs: state.configs.map((c) => {
          const cId = c.config_id ?? c.id;
          const pId = action.payload?.config_id ?? action.payload?.id;
          return cId === pId ? action.payload : c;
        }),
      };
    case T.UPDATE_NOTIFICATION_CONFIG_FAILURE:
      return { ...state, saving: false, error: action.payload };

    default:
      return state;
  }
}
